import React, { useState, useEffect, useRef, useCallback } from 'react';
import api from '../../services/api';
import { css, msg, fmtFecha, CARGOS, TIPOS_EVAL, Cab, Campo } from './comun';
import { RIESGOS } from './catalogos';
import Vitales, { css as cssVitales } from './Vitales';
import Diagnosticos, { css as cssCie } from './Cie10';
import { imprimirFemo } from './femoPrint';
import { REGIONES, INSTITUCIONES, SANGRE, LATERALIDAD, BLOQUES, base, fusionar, setIn, imcDe, nombresDe } from './femoDef';

/* Fase 2b — Formulario de Evaluación Médica Ocupacional (FEMO), bloques A–N, de principio a fin en una sola pantalla.
   Solo lo abre el profesional que atiende (el servidor lo exige). Se guarda como borrador las veces que haga falta
   (también solo, cada 45 s) y se completa al final. Un FEMO completo no se edita: se reabre con motivo. */

const extra = `
.fx-nav{display:flex;gap:6px;flex-wrap:wrap;padding:10px 20px;background:#fff;border-bottom:1px solid var(--border);position:sticky;top:0;z-index:5;}
.fx-chip{border:1px solid var(--border);background:#fff;border-radius:14px;padding:3px 10px;font-size:11px;font-weight:700;color:var(--text2);cursor:pointer;}
.fx-chip:hover{background:var(--blue-lt);}
.fx-chip.off{opacity:.4;}
.fx-bloque{border-top:1px solid var(--border);}
.fx-bloque > h3{margin:0;padding:12px 20px;font-size:12px;font-weight:700;letter-spacing:.5px;text-transform:uppercase;color:var(--navy);background:var(--blue-lt);}
.fx-bloque > .fx-c{padding:16px 20px;display:flex;flex-direction:column;gap:14px;}
.fx-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(190px,1fr));gap:12px 16px;}
.fx-sub{font-size:10.5px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;color:var(--text3);border-bottom:1px solid var(--bg);padding-bottom:3px;}
.fx-scroll{overflow-x:auto;}
.fx-t{width:100%;border-collapse:collapse;min-width:620px;}
.fx-t th{font-size:10.5px;text-transform:uppercase;color:var(--text3);text-align:left;padding:4px 6px;font-weight:700;}
.fx-t td{padding:3px 4px;vertical-align:middle;}
.fx-t td.c{text-align:center;}
.fx-reg{display:grid;grid-template-columns:repeat(auto-fill,minmax(230px,1fr));gap:10px;}
.fx-reg > div{border:1px solid var(--border);border-radius:8px;padding:8px 10px;background:#fff;}
.fx-reg b{font-size:11.5px;color:var(--navy);display:block;margin-bottom:4px;}
.fx-reg label{display:flex;gap:6px;align-items:center;font-size:12px;color:var(--text2);padding:1px 0;cursor:pointer;}
.fx-bar{position:sticky;bottom:0;z-index:6;background:#fff;border-top:2px solid var(--border);padding:10px 20px;display:flex;gap:10px;align-items:center;flex-wrap:wrap;}
.fx-ro{background:var(--bg);color:var(--text);}
.fx-imc{font-weight:700;color:var(--navy);}
.fx-lista{margin:6px 0 0 18px;padding:0;font-size:12.5px;}
fieldset.fx-fs{border:0;margin:0;padding:0;min-width:0;}
fieldset.fx-fs:disabled input,fieldset.fx-fs:disabled select,fieldset.fx-fs:disabled textarea{background:var(--bg);color:var(--text);}
`;

const TIPO_ES = TIPOS_EVAL;

/* ── controles ── */
const Inp = ({ v, set, t = 'text', ph, w, ...r }) => (
  <input className="form-control" type={t} value={v ?? ''} placeholder={ph} style={w ? { width: w } : undefined} onChange={e => set(e.target.value)} {...r} />
);
const Area = ({ v, set, filas = 3, ph }) => <textarea className="form-control" rows={filas} value={v ?? ''} placeholder={ph} onChange={e => set(e.target.value)} />;
const Chk = ({ v, set, children, dis }) => (
  <label className="mo-chk"><input type="checkbox" checked={!!v} disabled={dis} onChange={e => set(e.target.checked)} /> {children}</label>
);
const Opc = ({ v, set, opciones, nombre }) => (
  <div className="mo-lin">{opciones.map(([k, t]) => (
    <label key={k} className="mo-chk"><input type="radio" name={nombre} checked={v === k} onChange={() => set(v === k ? '' : k)} /> {t}</label>))}</div>
);
const Sel = ({ v, set, opciones, vacio = '—' }) => (
  <select className="form-control" value={v ?? ''} onChange={e => set(e.target.value)}>
    <option value="">{vacio}</option>{opciones.map(o => <option key={o} value={o}>{o}</option>)}
  </select>
);
const SINO = [['SI', 'Sí'], ['NO', 'No']];
const SINONR = [['SI', 'Sí'], ['NO', 'No'], ['NR', 'No responde']];

/** Tabla de filas que se agregan y se quitan. columnas: [{k, label, t: text|date|num|bool|sel, ops, w}] */
function Filas({ filas, set, max, nueva, columnas, agregar = 'Agregar fila' }) {
  const cambia = (i, k, v) => set(filas.map((f, j) => (j === i ? { ...f, [k]: v } : f)));
  return (
    <div>
      {filas.length > 0 && (
        <div className="fx-scroll"><table className="fx-t">
          <thead><tr>{columnas.map(c => <th key={c.k}>{c.label}</th>)}<th /></tr></thead>
          <tbody>{filas.map((f, i) => (
            <tr key={i}>{columnas.map(c => (
              <td key={c.k} className={c.t === 'bool' ? 'c' : ''} style={c.w ? { width: c.w } : undefined}>
                {c.t === 'bool' ? <input type="checkbox" checked={!!f[c.k]} onChange={e => cambia(i, c.k, e.target.checked)} />
                  : c.t === 'sel' ? <select className="form-control" value={f[c.k] ?? ''} onChange={e => cambia(i, c.k, e.target.value)}><option value="">—</option>{c.ops.map(([k, t]) => <option key={k} value={k}>{t}</option>)}</select>
                    : <input className="form-control" type={c.t === 'date' ? 'date' : 'text'} inputMode={c.t === 'num' ? 'decimal' : undefined} value={f[c.k] ?? ''} onChange={e => cambia(i, c.k, e.target.value)} />}
              </td>))}
              <td><button type="button" className="btn btn-sm" title="Quitar fila" onClick={() => set(filas.filter((_, j) => j !== i))}>✕</button></td></tr>))}
          </tbody></table></div>)}
      {filas.length < max && <button type="button" className="btn btn-sm" style={{ marginTop: 6 }} onClick={() => set([...filas, nueva()])}>+ {agregar}</button>}
    </div>
  );
}

const Bloque = ({ id, titulo, children }) => (
  <section className="fx-bloque" id={'fx-' + id}><h3>{id.toUpperCase()}. {titulo}</h3><div className="fx-c">{children}</div></section>
);

/* ═════════════════ pantalla ═════════════════ */
export default function Femo({ id, onVolver }) {
  const [carga, setCarga] = useState(null);                 // respuesta del servidor
  const [d, setD] = useState(base());
  const [err, setErr] = useState('');
  const [faltan, setFaltan] = useState([]);
  const [info, setInfo] = useState('');
  const [guardando, setGuardando] = useState(false);
  const [sucio, setSucio] = useState(false);
  const [motivo, setMotivo] = useState('');
  const [reabrir, setReabrir] = useState(false);
  const refD = useRef(d); refD.current = d;
  const refSucio = useRef(false); refSucio.current = sucio;

  const cargar = useCallback(async () => {
    try {
      const r = await api.get(`/ocupacional/evaluaciones/${id}/femo`);
      const pre = r.data.precarga || {};
      let dd = fusionar(base(), r.data.datos || {});
      if (!r.data.datos && pre.puesto) {                    // primera vez: actividades, riesgos y medidas llegan del puesto
        dd = { ...dd, g: { actividades: pre.puesto.ACTIVIDADES || dd.g.actividades, riesgos: { ...(pre.puesto.RIESGOS || {}) }, medidas: pre.puesto.MEDIDAS || '' } };
      }
      setCarga(r.data); setD(dd); setSucio(false); setErr('');
    } catch (e) { setErr(msg(e)); }
  }, [id]);
  useEffect(() => { cargar(); }, [cargar]);

  const pre = (carga && carga.precarga) || {};
  const tr = pre.trabajador || {}; const em = pre.empresa || {}; const pu = pre.puesto; const pf = pre.profesional || {};
  const tipo = (carga && carga.tipo) || pre.tipo;
  const editable = !!(carga && carga.editable);
  const sexo = tr.SEXO || d.a.sexo;
  const nac = tr.FECHA_NACIMIENTO || d.a.fecha_nac;
  const set = (ruta, valor) => { setD(p => setIn(p, ruta, valor)); setSucio(true); setInfo(''); };

  async function guardar(silencioso = false) {
    if (!editable) return false;
    if (!silencioso) setGuardando(true);
    try {
      const r = await api.put(`/ocupacional/evaluaciones/${id}/femo`, { datos: refD.current });
      setCarga(c => ({ ...c, estado: r.data.estado }));
      setD(p => ({ ...p, e: { ...p.e, imc: r.data.datos.e.imc } }));
      setSucio(false); setErr('');
      setInfo(`Guardado a las ${new Date().toTimeString().slice(0, 5)}`);
      return true;
    } catch (e) { if (!silencioso) setErr(msg(e)); return false; }
    finally { if (!silencioso) setGuardando(false); }
  }
  useEffect(() => {                                          // guarda solo cada 45 s si hay cambios
    if (!editable) return undefined;
    const t = setInterval(() => { if (refSucio.current) guardar(true); }, 45000);
    return () => clearInterval(t);
  }, [editable, id]);

  async function completar() {
    setFaltan([]); setErr('');
    if (!(await guardar())) return;
    setGuardando(true);
    try {
      await api.post(`/ocupacional/evaluaciones/${id}/femo/completar`);
      await cargar(); setInfo('FEMO completo.');
    } catch (e) {
      const dd = e && e.response && e.response.data;
      if (dd && dd.faltan) { setFaltan(dd.faltan); setErr(dd.error); } else setErr(msg(e));
    } finally { setGuardando(false); }
  }
  async function confirmarReabrir() {
    try { await api.post(`/ocupacional/evaluaciones/${id}/femo/reabrir`, { motivo }); setReabrir(false); setMotivo(''); await cargar(); }
    catch (e) { setErr(msg(e)); }
  }
  useEffect(() => { if (err) { const el = document.getElementById('fx-alerta'); if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }, [err, faltan]);
  const irA = b => { const el = document.getElementById('fx-' + b); if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); };

  if (!carga) {
    return <div className="mo-card"><Cab onVolver={onVolver} titulo="Formulario FEMO" />{err ? <div className="mo-alert">{err}</div> : <div style={{ padding: 40 }}><div className="spinner" style={{ margin: '0 auto' }} /></div>}</div>;
  }
  const [a1, a2, n1, n2] = [...nombresDe(tr.APELLIDOS), ...nombresDe(tr.NOMBRES)];
  const imc = imcDe(parseFloat(String(d.e.peso).replace(',', '.')), parseFloat(String(d.e.talla).replace(',', '.')));
  const retiro = tipo === 'RETIRO';
  const hoy = pre.fecha_atencion;
  const reaper = (carga.datos && carga.datos._reaperturas) || [];
  const visibles = BLOQUES.filter(([b]) => !(b === 'l' && retiro) && !(b === 'n' && !retiro));
  const hombre = sexo === 'H'; const mujer = sexo === 'M';

  return (
    <div className="mo-card fade-up">
      <style>{css + extra + cssVitales + cssCie}</style>
      <Cab onVolver={onVolver} titulo="Formulario de Evaluación Médica Ocupacional" sub={`${tr.APELLIDOS || ''} ${tr.NOMBRES || ''} · ${em.RAZON_SOCIAL || ''} · ${TIPO_ES[tipo] || tipo} · ${fmtFecha(hoy)}`}>
        <span className={'badge ' + (carga.estado === 'FEMO_LISTO' || carga.estado === 'CERTIFICADO' ? 'badge-green' : 'badge-amber')}>{carga.estado === 'CERTIFICADO' ? 'Certificado emitido' : carga.estado === 'FEMO_LISTO' ? 'FEMO completo' : 'En elaboración'}</span>
      </Cab>
      {err && <div className="mo-alert" id="fx-alerta">{err}{faltan.length > 0 && <ul className="fx-lista">{faltan.map((f, i) => <li key={i}>{f}</li>)}</ul>}</div>}
      {info && !err && <div className="mo-ok">{info}</div>}
      {carga.estado === 'CERTIFICADO' && <div className="mo-ok">El FEMO está completo y ya se emitió el certificado, por eso no se puede editar. Para corregirlo hay que anular primero el certificado (en el detalle de la evaluación). <button className="btn btn-sm" onClick={() => imprimirFemo(carga.datos, carga.firma_profesional)}>🖨 Imprimir FEMO / PDF</button></div>}
      {carga.estado === 'FEMO_LISTO' && (
        <div className="mo-ok">
          El FEMO está completo y ya no se puede editar. <button className="btn btn-sm" onClick={() => imprimirFemo(carga.datos, carga.firma_profesional)}>🖨 Imprimir FEMO / PDF</button> {!reabrir && <button className="btn btn-sm" onClick={() => setReabrir(true)}>Reabrir para corregir</button>}
          {reabrir && (
            <span className="mo-lin" style={{ marginTop: 8 }}>
              <input className="form-control" style={{ maxWidth: 300 }} placeholder="Motivo (mínimo 5 letras)" value={motivo} onChange={e => setMotivo(e.target.value)} />
              <button className="btn btn-sm btn-primary" disabled={motivo.trim().length < 5} onClick={confirmarReabrir}>Reabrir</button>
              <button className="btn btn-sm" onClick={() => { setReabrir(false); setMotivo(''); }}>Cancelar</button>
            </span>)}
        </div>)}
      {reaper.length > 0 && <div className="mo-cuerpo">{reaper.map((r, i) => <div key={i} className="mo-sub">Reabierto el {fmtFecha(r.fecha)} por {r.usuario}: {r.motivo}</div>)}</div>}
      <div className="fx-nav">{visibles.map(([b, t]) => <button key={b} type="button" className="fx-chip" title={t} onClick={() => irA(b)}>{b.toUpperCase()}</button>)}</div>

      <fieldset className="fx-fs" disabled={!editable}>
        {/* A */}
        <Bloque id="a" titulo="Datos del establecimiento · datos del trabajador">
          <div className="fx-grid">
            <Campo label="Institución del sistema"><Sel v={d.a.institucion} set={v => set(['a', 'institucion'], v)} opciones={INSTITUCIONES} vacio="No corresponde" /></Campo>
            <Campo label="RUC"><div className="mo-dato mo-mono">{em.RUC || '—'}</div></Campo>
            <Campo label="CIIU"><div className="mo-dato">{em.CIIU || '—'}</div></Campo>
            <Campo label="Establecimiento / centro de trabajo"><div className="mo-dato">{em.NOMBRE_COMERCIAL || em.RAZON_SOCIAL}</div></Campo>
            <Campo label="Número de historia clínica"><div className="mo-dato mo-mono">{tr.IDENTIFICACION}</div></Campo>
            <Campo label="Número de archivo"><Inp v={d.a.archivo} set={v => set(['a', 'archivo'], v)} /></Campo>
          </div>
          <div className="fx-grid">
            <Campo label="Primer apellido"><div className="mo-dato">{a1}</div></Campo>
            <Campo label="Segundo apellido"><div className="mo-dato">{a2 || '—'}</div></Campo>
            <Campo label="Primer nombre"><div className="mo-dato">{n1}</div></Campo>
            <Campo label="Segundo nombre"><div className="mo-dato">{n2 || '—'}</div></Campo>
          </div>
          <div className="fx-grid">
            <Campo label="Sexo" req={!tr.SEXO}>{tr.SEXO ? <div className="mo-dato">{tr.SEXO === 'H' ? 'Hombre' : 'Mujer'}</div>
              : <select className="form-control" value={d.a.sexo} onChange={e => set(['a', 'sexo'], e.target.value)}><option value="">—</option><option value="H">Hombre</option><option value="M">Mujer</option></select>}</Campo>
            <Campo label="Fecha de nacimiento" req={!tr.FECHA_NACIMIENTO}>{tr.FECHA_NACIMIENTO ? <div className="mo-dato">{fmtFecha(tr.FECHA_NACIMIENTO)}</div>
              : <Inp t="date" v={d.a.fecha_nac} set={v => set(['a', 'fecha_nac'], v)} />}</Campo>
            <Campo label="Edad (años)"><div className="mo-dato">{tr.EDAD != null ? tr.EDAD : '—'}</div></Campo>
            <Campo label="Grupo sanguíneo"><Sel v={d.a.sangre} set={v => set(['a', 'sangre'], v)} opciones={SANGRE} /></Campo>
            <Campo label="Lateralidad"><Opc nombre="later" v={d.a.lateralidad} set={v => set(['a', 'lateralidad'], v)} opciones={LATERALIDAD.map(x => [x, x[0] + x.slice(1).toLowerCase()])} /></Campo>
          </div>
          <div>
            <div className="fx-sub">Grupo de atención prioritaria</div>
            <div className="mo-lin" style={{ marginTop: 6 }}>
              <Chk v={d.a.prioritaria.embarazada} dis={hombre} set={v => set(['a', 'prioritaria', 'embarazada'], v)}>Embarazada</Chk>
              <Chk v={d.a.prioritaria.discapacidad} set={v => set(['a', 'prioritaria', 'discapacidad'], v)}>Persona con discapacidad</Chk>
              <Chk v={d.a.prioritaria.catastrofica} set={v => set(['a', 'prioritaria', 'catastrofica'], v)}>Enfermedad catastrófica</Chk>
              <Chk v={d.a.prioritaria.adulto_mayor} set={v => set(['a', 'prioritaria', 'adulto_mayor'], v)}>Adulto mayor (65 años o más)</Chk>
            </div>
          </div>
          <div className="mo-sub">Los datos fijos vienen de la empresa y de la nómina. Si alguno está mal, corríjalo allá, no aquí.</div>
        </Bloque>

        {/* B */}
        <Bloque id="b" titulo="Motivo de consulta">
          <div className="fx-grid">
            <Campo label="Puesto de trabajo (CIUO)"><div className="mo-dato">{pu ? `${pu.NOMBRE}${pu.CIUO ? ` (${pu.CIUO})` : ''}` : 'Sin puesto asignado en la nómina'}</div></Campo>
            <Campo label="Fecha de atención"><div className="mo-dato">{fmtFecha(hoy)}</div></Campo>
            <Campo label="Fecha de ingreso al trabajo"><div className="mo-dato">{fmtFecha(tr.FECHA_INGRESO)}</div></Campo>
            {tipo === 'REINTEGRO' && <Campo label="Fecha de reintegro"><Inp t="date" v={d.b.fecha_reintegro} set={v => set(['b', 'fecha_reintegro'], v)} /></Campo>}
            {retiro && <Campo label="Último día laboral / salida"><div className="mo-dato">{fmtFecha(tr.FECHA_SALIDA)}</div></Campo>}
            <Campo label="Tipo de evaluación"><div className="mo-dato"><b>{TIPO_ES[tipo]}</b></div></Campo>
          </div>
          <Campo label="Observación"><Area v={d.b.observacion} set={v => set(['b', 'observacion'], v)} filas={2} /></Campo>
        </Bloque>

        {/* C */}
        <Bloque id="c" titulo="Antecedentes personales">
          <Campo label="Antecedentes clínicos y quirúrgicos" req><Area v={d.c.clinicos} set={v => set(['c', 'clinicos'], v)} ph="Enfermedades, alergias, traumatismos, cirugías. Escriba «Ninguno» si no hay." /></Campo>
          <Campo label="Antecedentes familiares"><Area v={d.c.familiares} set={v => set(['c', 'familiares'], v)} ph="Parentesco y patología de importancia (cardiovascular, metabólica, neurológica, oncológica, infecciosa, hereditaria…)" /></Campo>
          <div className="fx-sub">Condición especial para atenciones de urgencia (referido por el trabajador)</div>
          <div className="fx-grid">
            <Campo label="En caso de requerir transfusiones, autoriza"><Opc nombre="transf" v={d.c.transfusion} set={v => set(['c', 'transfusion'], v)} opciones={SINO} /></Campo>
            <Campo label="¿Se encuentra bajo tratamiento hormonal?"><Opc nombre="horm" v={d.c.hormonal.v} set={v => set(['c', 'hormonal', 'v'], v)} opciones={SINO} /></Campo>
            {d.c.hormonal.v === 'SI' && <Campo label="¿Cuál?"><Inp v={d.c.hormonal.cual} set={v => set(['c', 'hormonal', 'cual'], v)} /></Campo>}
          </div>
          {!hombre && (<>
            <div className="fx-sub">Antecedentes ginecoobstétricos {mujer ? '' : '(solo si es mujer)'}</div>
            <div className="fx-grid">
              <Campo label="Fecha de última menstruación"><Inp t="date" v={d.c.gineco.fum} set={v => set(['c', 'gineco', 'fum'], v)} /></Campo>
              {[['gestas', 'Gestas'], ['partos', 'Partos'], ['cesareas', 'Cesáreas'], ['abortos', 'Abortos']].map(([k, t]) => (
                <Campo key={k} label={t}><Inp t="number" min="0" max="30" v={d.c.gineco[k]} set={v => set(['c', 'gineco', k], v)} /></Campo>))}
              <Campo label="Método de planificación familiar"><Opc nombre="planf" v={d.c.gineco.planif.v} set={v => set(['c', 'gineco', 'planif', 'v'], v)} opciones={SINONR} /></Campo>
              {d.c.gineco.planif.v === 'SI' && <Campo label="¿Cuál?"><Inp v={d.c.gineco.planif.cual} set={v => set(['c', 'gineco', 'planif', 'cual'], v)} /></Campo>}
            </div>
            <Filas filas={d.c.gineco.examenes} set={v => set(['c', 'gineco', 'examenes'], v)} max={6} nueva={() => ({ nombre: '', tiempo: '', resultado: '' })} agregar="Examen realizado"
              columnas={[{ k: 'nombre', label: 'Examen (Papanicolaou, mamografía…)' }, { k: 'tiempo', label: 'Tiempo (años)', t: 'num', w: 110 }, { k: 'resultado', label: 'Resultado (solo si interfiere con el trabajo y hay autorización)' }]} />
          </>)}
          {!mujer && (<>
            <div className="fx-sub">Antecedentes reproductivos masculinos {hombre ? '' : '(solo si es hombre)'}</div>
            <Filas filas={d.c.masculino.examenes} set={v => set(['c', 'masculino', 'examenes'], v)} max={6} nueva={() => ({ nombre: '', tiempo: '', resultado: '' })} agregar="Examen realizado"
              columnas={[{ k: 'nombre', label: 'Examen (PSA, eco…)' }, { k: 'tiempo', label: 'Tiempo (años)', t: 'num', w: 110 }, { k: 'resultado', label: 'Resultado (solo si interfiere con el trabajo y hay autorización)' }]} />
            <div className="fx-grid">
              <Campo label="Método de planificación familiar"><Opc nombre="planm" v={d.c.masculino.planif.v} set={v => set(['c', 'masculino', 'planif', 'v'], v)} opciones={SINONR} /></Campo>
              {d.c.masculino.planif.v === 'SI' && <Campo label="¿Cuál?"><Inp v={d.c.masculino.planif.cual} set={v => set(['c', 'masculino', 'planif', 'cual'], v)} /></Campo>}
            </div>
          </>)}
          <div className="fx-sub">Consumo de sustancias</div>
          <div className="fx-scroll"><table className="fx-t">
            <thead><tr><th /><th>No consume</th><th>Tiempo de consumo</th><th>Cantidad (por semana)</th><th>Ex consumidor</th><th>Abstinencia (meses)</th></tr></thead>
            <tbody>{[['tabaco', 'Tabaco'], ['alcohol', 'Alcohol'], ['otras', 'Otras sustancias']].map(([k, t]) => (
              <tr key={k}><td><b style={{ fontSize: 12 }}>{t}</b>{k === 'otras' && <input className="form-control" placeholder="¿Cuál?" value={d.c.consumo.otras.cual} onChange={e => set(['c', 'consumo', 'otras', 'cual'], e.target.value)} />}</td>
                <td className="c"><input type="checkbox" checked={d.c.consumo[k].no_consume} onChange={e => set(['c', 'consumo', k, 'no_consume'], e.target.checked)} /></td>
                <td><input className="form-control" value={d.c.consumo[k].tiempo} onChange={e => set(['c', 'consumo', k, 'tiempo'], e.target.value)} /></td>
                <td><input className="form-control" value={d.c.consumo[k].cantidad} onChange={e => set(['c', 'consumo', k, 'cantidad'], e.target.value)} /></td>
                <td className="c"><input type="checkbox" checked={d.c.consumo[k].ex} onChange={e => set(['c', 'consumo', k, 'ex'], e.target.checked)} /></td>
                <td style={{ width: 130 }}><input className="form-control" inputMode="numeric" value={d.c.consumo[k].abstinencia} onChange={e => set(['c', 'consumo', k, 'abstinencia'], e.target.value)} /></td></tr>))}
            </tbody></table></div>
          <Campo label="Observación sobre el consumo"><Inp v={d.c.consumo.observacion} set={v => set(['c', 'consumo', 'observacion'], v)} /></Campo>
          <div className="fx-grid">
            <div><div className="fx-sub">Estilo de vida</div>
              <div style={{ marginTop: 6 }}><Chk v={d.c.estilo.actividad} set={v => set(['c', 'estilo', 'actividad'], v)}>Realiza actividad física</Chk></div>
              {d.c.estilo.actividad && <div className="fx-grid" style={{ marginTop: 8 }}>
                <Campo label="¿Cuál?"><Inp v={d.c.estilo.cual} set={v => set(['c', 'estilo', 'cual'], v)} /></Campo>
                <Campo label="Tiempo (ej. 3 horas a la semana)"><Inp v={d.c.estilo.tiempo} set={v => set(['c', 'estilo', 'tiempo'], v)} /></Campo></div>}
            </div>
            <div><div className="fx-sub">Condición preexistente</div>
              <div style={{ marginTop: 6 }}><Chk v={d.c.medicacion.habitual} set={v => set(['c', 'medicacion', 'habitual'], v)}>Toma medicación habitual</Chk></div>
              {d.c.medicacion.habitual && <div className="fx-grid" style={{ marginTop: 8 }}>
                <Campo label="¿Cuál? (nombre genérico)"><Inp v={d.c.medicacion.cual} set={v => set(['c', 'medicacion', 'cual'], v)} /></Campo>
                <Campo label="Cantidad (ej. 1 cápsula / día)"><Inp v={d.c.medicacion.cantidad} set={v => set(['c', 'medicacion', 'cantidad'], v)} /></Campo></div>}
            </div>
          </div>
        </Bloque>

        {/* D */}
        <Bloque id="d" titulo="Enfermedad o problema actual">
          <Area v={d.d.descripcion} set={v => set(['d', 'descripcion'], v)} filas={4} ph="Origen, evolución y características de los síntomas o signos, tratamientos efectuados…" />
        </Bloque>

        {/* E */}
        <Bloque id="e" titulo="Constantes vitales y antropometría">
          <Vitales e={d.e} set={set} sexo={sexo} imc={imc} />
          <div className="mo-sub">Los colores (bajo / normal / alto) son una ayuda referencial para adultos; el criterio es del médico. Obligatorios: todos menos el perímetro abdominal.</div>
        </Bloque>

        {/* F */}
        <Bloque id="f" titulo="Examen físico regional">
          <div className="mo-sub">Marque solo las regiones con evidencia de patología y descríbalas en observaciones, con el numeral.</div>
          <div className="fx-reg">{REGIONES.map(([n, nombre, items]) => (
            <div key={n}><b>{n}. {nombre}</b>{items.map(([k, t]) => (
              <label key={k}><input type="checkbox" checked={!!d.f.hallazgos[k]} onChange={e => set(['f', 'hallazgos'], { ...d.f.hallazgos, [k]: e.target.checked })} /> {k.replace(/^\d+/, '')}. {t}</label>))}</div>))}</div>
          <Campo label="Observaciones"><Area v={d.f.observacion} set={v => set(['f', 'observacion'], v)} filas={3} ph="Ej.: 1a cicatriz de 3 cm en antebrazo derecho" /></Campo>
        </Bloque>

        {/* G */}
        <Bloque id="g" titulo="Factores de riesgo del trabajo actual">
          <div className="mo-lin"><div className="mo-dato" style={{ flex: 1 }}><b>Puesto:</b> {pu ? `${pu.NOMBRE}${pu.CIUO ? ` (${pu.CIUO})` : ''}` : 'Sin puesto asignado en la nómina'}</div>
            {editable && pu && <button type="button" className="btn btn-sm" onClick={() => { set(['g'], { actividades: pu.ACTIVIDADES, riesgos: { ...pu.RIESGOS }, medidas: pu.MEDIDAS }); }}>Volver a cargar desde el puesto</button>}</div>
          <div className="mo-sub">Llegó precargado desde el puesto de la empresa. Corrija solo lo que cambió.</div>
          <div className="fx-sub">Actividades importantes dentro de la jornada laboral (hasta 7)</div>
          <div className="fx-grid">{d.g.actividades.map((a, i) => (
            <Campo key={i} label={`Actividad ${i + 1}`}><Inp v={a} set={v => set(['g', 'actividades'], d.g.actividades.map((x, j) => (j === i ? v : x)))} /></Campo>))}</div>
          <div className="mo-mxwrap"><table className="mo-mx">
            <thead><tr><th>Factor de riesgo</th>{[1, 2, 3, 4, 5, 6, 7].map(c => <th key={c} title={d.g.actividades[c - 1] || ''}>{c}</th>)}</tr></thead>
            <tbody>{RIESGOS.map(([cat, p, items]) => [
              <tr key={p} className="cat"><td colSpan={8}>{cat}</td></tr>,
              ...items.map((nom, i) => (
                <tr key={p + i}><td>{nom}</td>{[1, 2, 3, 4, 5, 6, 7].map(c => (
                  <td key={c} className="c"><input type="checkbox" checked={!!(d.g.riesgos[p + i] && d.g.riesgos[p + i][c])}
                    onChange={() => { const fila = { ...(d.g.riesgos[p + i] || {}) }; if (fila[c]) delete fila[c]; else fila[c] = true; const r = { ...d.g.riesgos }; if (Object.keys(fila).length) r[p + i] = fila; else delete r[p + i]; set(['g', 'riesgos'], r); }} /></td>))}</tr>))])}
            </tbody></table></div>
          <Campo label="Medidas preventivas"><Area v={d.g.medidas} set={v => set(['g', 'medidas'], v)} filas={3} /></Campo>
        </Bloque>

        {/* H */}
        <Bloque id="h" titulo="Actividad laboral · incidentes · accidentes · enfermedades ocupacionales">
          <div className="mo-sub">Empleos anteriores y/o trabajo actual.</div>
          <Filas filas={d.h.filas} set={v => set(['h', 'filas'], v)} max={12} agregar="Centro de trabajo"
            nueva={() => ({ centro: '', actividades: '', trabajo: '', tiempo: '', incidente: false, accidente: false, enfermedad: false, calificado: '', fecha: '', especificar: '', observaciones: '' })}
            columnas={[{ k: 'centro', label: 'Centro de trabajo' }, { k: 'actividades', label: 'Actividades que desempeñaba' }, { k: 'trabajo', label: 'Trabajo', t: 'sel', ops: [['ANTERIOR', 'Anterior'], ['ACTUAL', 'Actual']], w: 110 }, { k: 'tiempo', label: 'Tiempo (6 m, 4 a)', w: 100 },
              { k: 'incidente', label: 'Incidente', t: 'bool', w: 70 }, { k: 'accidente', label: 'Accidente', t: 'bool', w: 70 }, { k: 'enfermedad', label: 'Enf. profesional', t: 'bool', w: 80 },
              { k: 'calificado', label: 'Calificado IESS', t: 'sel', ops: [['SI', 'Sí'], ['NO', 'No']], w: 90 }, { k: 'fecha', label: 'Fecha', t: 'date', w: 140 }, { k: 'especificar', label: 'Especificar (entidad)' }, { k: 'observaciones', label: 'Observaciones' }]} />
        </Bloque>

        {/* I */}
        <Bloque id="i" titulo="Actividades extralaborales">
          <Filas filas={d.i.filas} set={v => set(['i', 'filas'], v)} max={8} agregar="Actividad" nueva={() => ({ tipo: '', fecha: '' })}
            columnas={[{ k: 'tipo', label: 'Tipo de actividad' }, { k: 'fecha', label: 'Fecha de inicio', t: 'date', w: 160 }]} />
          <Campo label="Descripción"><Area v={d.i.descripcion} set={v => set(['i', 'descripcion'], v)} filas={2} /></Campo>
        </Bloque>

        {/* J */}
        <Bloque id="j" titulo="Resultados de exámenes generales y específicos (imagen, laboratorio y otros)">
          <Filas filas={d.j.filas} set={v => set(['j', 'filas'], v)} max={10} agregar="Examen" nueva={() => ({ nombre: '', fecha: '', resultado: '' })}
            columnas={[{ k: 'nombre', label: 'Nombre del examen' }, { k: 'fecha', label: 'Fecha', t: 'date', w: 160 }, { k: 'resultado', label: 'Resultados (solo lo alterado o relevante)' }]} />
          <Campo label="Observaciones"><Area v={d.j.observaciones} set={v => set(['j', 'observaciones'], v)} filas={2} ph="Si todo es normal escriba «Normal». Los resultados deben anexarse a la evaluación." /></Campo>
        </Bloque>

        {/* K */}
        <Bloque id="k" titulo="Diagnóstico (CIE-10)">
          <Diagnosticos filas={d.k.filas} set={v => set(['k', 'filas'], v)} />
          {d.k.filas.length === 0 && <Chk v={d.k.sin_patologia} set={v => set(['k', 'sin_patologia'], v)}>Sin patología (no hay diagnósticos)</Chk>}
        </Bloque>

        {/* L */}
        {!retiro && (
          <Bloque id="l" titulo="Aptitud médica para el trabajo">
            <div className="mo-lin">{[['APTO', 'Apto'], ['OBSERVACION', 'Apto en observación'], ['LIMITACIONES', 'Apto con limitaciones'], ['NO_APTO', 'No apto']].map(([k, t]) => (
              <label key={k} className="mo-chk"><input type="radio" name="aptitud" checked={d.l.aptitud === k} onChange={() => set(['l', 'aptitud'], k)} /> <b>{t}</b></label>))}</div>
            {d.l.aptitud === 'LIMITACIONES' && (
              <div className="mo-lin">
                <Chk v={d.l.limitaciones.personales} set={v => set(['l', 'limitaciones', 'personales'], v)}>Limitación personal</Chk>
                <Chk v={d.l.limitaciones.adaptativas} set={v => set(['l', 'limitaciones', 'adaptativas'], v)}>Laboral adaptativa</Chk>
                <Chk v={d.l.limitaciones.restrictivas} set={v => set(['l', 'limitaciones', 'restrictivas'], v)}>Laboral restrictiva</Chk>
              </div>)}
            <Campo label="Observaciones"><Area v={d.l.observaciones} set={v => set(['l', 'observaciones'], v)} filas={2} ph="Uso exclusivamente médico y confidencial." /></Campo>
          </Bloque>)}

        {/* M */}
        <Bloque id="m" titulo="Recomendaciones y/o tratamiento">
          <Area v={d.m.descripcion} set={v => set(['m', 'descripcion'], v)} filas={4} ph="Tratamiento farmacológico y no farmacológico, restricciones, adaptaciones… Escriba «Ninguna» si no hay." />
        </Bloque>

        {/* N */}
        {retiro && (
          <Bloque id="n" titulo="Retiro (evaluación)">
            <div className="fx-grid">
              <Campo label="Se realiza la evaluación" req><Opc nombre="nreal" v={d.n.realiza} set={v => set(['n', 'realiza'], v)} opciones={SINO} /></Campo>
              <Campo label="La condición de salud está relacionada con el trabajo"><Opc nombre="nrel" v={d.n.relacionada} set={v => set(['n', 'relacionada'], v)} opciones={SINO} /></Campo>
            </div>
            <Campo label="Observación"><Area v={d.n.observacion} set={v => set(['n', 'observacion'], v)} filas={2} ph="Si no se realiza la evaluación, escriba el motivo." /></Campo>
          </Bloque>)}

        {/* O y P */}
        <Bloque id="o" titulo="Datos del profesional · firma o huella del trabajador">
          <div className="fx-grid">
            <Campo label="Nombres y apellidos del profesional"><div className="mo-dato">{pf.NOMBRE} · {CARGOS[pf.CARGO] || pf.CARGO}</div></Campo>
            <Campo label="Código médico (Registro MSP)"><div className="mo-dato mo-mono">{pf.REGISTRO_MSP || 'Falta: regístrelo en Configuración → Usuarios'}</div></Campo>
          </div>
          <div className="mo-note">Estos datos salen del usuario del profesional. La firma y sello del profesional y la firma o huella del trabajador se agregan al generar el PDF del formulario y el certificado (siguiente entrega).</div>
        </Bloque>
      </fieldset>

      <div className="fx-bar">
        {editable ? (<>
          <button className="btn" disabled={guardando} onClick={() => guardar()}>{guardando ? 'Guardando…' : 'Guardar borrador'}</button>
          <button className="btn btn-primary" disabled={guardando} onClick={completar}>✓ Completar FEMO</button>
          <span className="mo-foot-i">{sucio ? 'Hay cambios sin guardar (se guardan solos cada 45 s).' : info}</span>
        </>) : <span className="mo-foot-i">FEMO completo{carga.datos && carga.datos._snapshot ? ` el ${fmtFecha(carga.datos._snapshot.completado.fecha)}` : ''}. Siguiente: certificado y PDF (próxima entrega).</span>}
      </div>
    </div>
  );
}
